// react
import { MouseEventHandler } from 'react';

// router
import { Link as RouterLink } from 'react-router-dom';

// mui
import { AppBar, Box, IconButton, Grid, Link, Toolbar } from '@mui/material';

// icons
import { MenuOutlined as IconMenu } from '@mui/icons-material';

// logos
import { LogoFundsChainAlt } from '../../img/LogoFundsChainAlt';

// ui
import { BtnBack } from '../BtnBack/BtnBack';

// props
export interface HeaderProps {
	onOpenNav?: MouseEventHandler;
}

// types
export type Anchor = HTMLButtonElement | null;

export const Header = ({ onOpenNav }: HeaderProps) => {
	return (
		<AppBar
			color="secondary"
			elevation={0}
			position="static"
			sx={(theme) => {
				return {
					backgroundColor: `rgba(0,0,0,0.3)`,
					flexDirection: 'row',
					alignItems: 'center',
					borderRadius: `0 !important`,
					height: theme.variables?.headerHeight,
				};
			}}>
			<Toolbar
				disableGutters={true}
				sx={(theme) => {
					return {
						justifyContent: 'space-between',
						padding: theme.spacing(0, 3),
						width: '100%',
						height: '100%',
						minHeight: `0 !important`,
					};
				}}>
				<Grid alignItems="center" container columnSpacing={2}>
					<Grid item xs={4}>
						<BtnBack pathsExcluded={['/dashboard']} />
					</Grid>

					<Grid item xs={4} sx={{ textAlign: 'center' }}>
						<Link color="common.white" component={RouterLink} to="/dashboard" underline="none">
							<Box sx={{ display: 'inline-flex', width: '150px' }}>
								<LogoFundsChainAlt />
							</Box>
						</Link>
					</Grid>

					<Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
						<IconButton color="white" onClick={onOpenNav}>
							<IconMenu />
						</IconButton>
					</Grid>
				</Grid>
			</Toolbar>
		</AppBar>
	);
};
